import { useEffect } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { privateApi } from "@/api/axios";
import { careplanQueryOptions } from "@/domains/careplan/factories/careplan-query-options";
import type { CareplanModel, MarkCareplanAsReadRequest } from "@/domains/careplan/models/types";

const markCareplanAsRead = async ({ careplanId }: MarkCareplanAsReadRequest) => {
  await privateApi.patch(`/careplans/${careplanId}/read`);
};

type UseMarkCareplanAsReadArgs = {
  isRead?: boolean;
  careplanId?: CareplanModel["id"];
};

export const useMarkCareplanAsRead = ({ careplanId, isRead }: UseMarkCareplanAsReadArgs) => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationFn: markCareplanAsRead,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: careplanQueryOptions.current.queryKey,
      });
    },
  });

  useEffect(() => {
    if (!isRead && careplanId) {
      mutate({ careplanId });
    }
  }, [isRead, careplanId, mutate]);
};
